import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=afc8fd30&scoped=true"
import script from "./OrganisationList.vue?vue&type=script&lang=js"
export * from "./OrganisationList.vue?vue&type=script&lang=js"
import style0 from "./OrganisationList.vue?vue&type=style&index=0&id=afc8fd30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc8fd30",
  null
  
)

export default component.exports